module.exports = __webpack_public_path__ + "static/iso_ts_20660_2019_en_-e72a635bc64ec2fe39b3803b20474309.pdf";